import { AuthLayout, DefaultLayout, PageLayout } from '@/components/layouts'

export const RootViews = {
  path: '/',
  redirect: '/sign-in'
}

export const SignInViews = {
  path: '/',
  component: AuthLayout,
  name: 'Sign In',
  children: [
    {
      path: '/sign-in',
      name: 'SignIn',
      component: () => import('@/views/system/SignIn.vue')
    }
  ]
}

export const SystemViews = {
  path: '/',
  component: DefaultLayout,
  meta: {
    title: 'App',
    group: 'system'
  },
  redirect: '/welcome',
  children: [
    {
      path: '/welcome',
      name: 'Welcome',
      meta: {
        title: 'Welcome'
      },
      component: () => import('@/views/system/Welcome.vue')
    },
    {
      path: '/error',
      name: 'Error',
      meta: {
        title: 'Error'
      },
      component: () => import('@/views/error/Error.vue')
    },
    {
      path: '/403',
      name: 'Deny',
      meta: {
        title: '403'
      },
      component: () => import('@/views/error/Deny.vue')
    },
    {
      path: '/404',
      name: 'NotFound',
      meta: {
        title: '404'
      },
      component: () => import('@/views/error/NotFound.vue')
    }
  ]
}

export const PreOriginationViews = {
  path: '/',
  component: DefaultLayout,
  meta: {
    title: 'Pre-Origination',
    icon: 'apps',
    group: 'los'
  },
  children: [
    {
      path: '/pre-origination/workbench',
      name: 'pre-origination.workbench',
      meta: {
        title: 'Pre-Origination / Workbench'
      },
      component: () => import('@/views/pre-origination/Workbench.vue')
    },
    {
      path: '/pre-origination/application/queue',
      name: 'pre-origination.loan.queue',
      meta: {
        title: 'Pre-Origination / Work Queue'
      },
      component: () => import('@/views/pre-origination/ApplicationQueue.vue')
    },
    {
      path: '/',
      name: 'pre-origination.loan.detail',
      component: PageLayout,
      children: [
        {
          path: '/pre-origination/application',
          name: 'Loan Detail',
          meta: {
            title: 'Pre-Origination / Loan Detail'
          },
          component: () => import('@/views/pre-origination/ApplicationDetail.vue')
        }
      ]
    },
    {
      path: '/',
      name: 'pre-origination.manually.create.lead',
      component: PageLayout,
      children: [
        {
          path: '/pre-origination/manually-create-lead',
          name: 'Manually Create Lead',
          meta: {
            title: 'Pre-Origination / Manually Create Lead '
          },
          component: () => import('@/views/pre-origination/ManuallyCreateLead.vue')
        }
      ]
    }
  ]
}

export const PostOriginationViews = {
  path: '/',
  component: DefaultLayout,
  meta: {
    title: 'Post-Origination',
    icon: 'apps',
    group: 'pps'
  },
  children: [
    {
      path: '/post-origination/application/queue',
      name: 'post-origination.loan.queue',
      meta: {
        title: 'Post-Origination / Work Queue'
      },
      component: () => import('@/views/post-origination/ApplicationQueue.vue')
    },
    {
      path: '/post-origination/special/queue',
      name: 'post-origination.special.queue',
      meta: {
        title: 'Post-Origination / Special Queue'
      },
      component: () => import('@/views/post-origination/SpecialQueue.vue')
    },
    {
      path: '/post-origination/complaint/queue',
      name: 'post-origination.complaint.queue',
      meta: {
        title: 'Post-Origination / Complaint Queue'
      },
      component: () => import('@/views/post-origination/ComplaintQueue.vue')
    },
    {
      path: '/post-origination/toBeConfirmed/queue',
      name: 'post-origination.toBeConfirmed.queue',
      meta: {
        title: 'Post-Origination / To Be Confirmed Queue'
      },
      component: () => import('@/views/post-origination/ToBeConfirmQueue.vue')
    },
    {
      path: '/',
      name: 'post-origination.loan.detail',
      component: PageLayout,
      children: [
        {
          path: '/post-origination/application/:uuid',
          name: 'Post Loan Detail',
          meta: {
            title: 'Post-Origination / Loan Detail'
          },
          component: () => import('@/views/post-origination/ApplicationDetail.vue')
        }
      ]
    }
  ]
}

export const CollectionViews = {
  path: '/',
  component: DefaultLayout,
  meta: {
    title: 'Collection',
    icon: 'apps',
    group: 'pps'
  },
  children: [
    {
      path: '/collection/application/queue',
      name: 'collection.loan.queue',
      meta: {
        title: 'Collection / Loan Queue',
        icon: 'layers'
      },
      component: () => import('@/views/collection/ApplicationQueue.vue')
    },
    {
      path: '/collection/third-party/external-overflow-queue',
      name: 'Collection Third Party Overflow Queue',
      meta: {
        title: 'External Collection / Overflow Queue'
      },
      component: () => import('@/views/collection/third-party/OverflowQueue.vue')
    },
    {
      path: '/collection/in-house/in-house-overflow-queue',
      name: 'Collection In House In House Overflow Queue',
      meta: {
        title: 'In-House Collection / Overflow Queue'
      },
      component: () => import('@/views/collection/in-house/InHouseOverflowQueue.vue')
    },
    {
      path: '/collection/in-house/in-house-special-queue',
      name: 'Collection In House In House Special Queue',
      meta: {
        title: 'In-House Collection / Special Queue'
      },
      component: () => import('@/views/collection/in-house/InHouseSpecialQueue.vue')
    },
    {
      path: '/collection/third-party/queue',
      name: 'Collection Third Party Queue',
      meta: {
        title: 'External Collection / Work Queue'
      },
      component: () => import('@/views/collection/third-party/Queue.vue')
    },
    {
      path: '/collection/in-house/in-house-queue',
      name: 'Collection In House In House Queue',
      meta: {
        title: 'In-House Collection / Work Queue'
      },
      component: () => import('@/views/collection/in-house/InHouseQueue.vue')
    },
    {
      path: '/collection/in-house/cccs-queue',
      name: 'Collection In House CCCS Queue',
      meta: {
        title: 'In-House Collection / CCCS Queue'
      },
      component: () => import('@/views/collection/in-house/CCCSQueue.vue')
    },
    {
      path: '/collection/in-house/bankruptcy-queue',
      name: 'Collection In House Bankruptcy Queue',
      meta: {
        title: 'In-House Collection / Bankruptcy Queue'
      },
      component: () => import('@/views/collection/in-house/BankruptcyQueue.vue')
    },
    {
      path: '/collection/in-house/miscellaneous-queue',
      name: 'Collection In House Miscellaneous Queue',
      meta: {
        title: 'In-House Collection / Miscellaneous Queue'
      },
      component: () => import('@/views/collection/in-house/MiscellaneousQueue.vue')
    },
    {
      path: '/',
      name: 'collection.loan.detail',
      component: PageLayout,
      children: [
        {
          path: '/collection/application/:uuid',
          name: 'Collection Loan Detail',
          meta: {
            title: 'Collection / Loan Detail'
          },
          component: () => import('@/views/collection/ApplicationDetail.vue')
        },
        {
          path: '/collection/third-party/upload',
          name: 'Collection Third Party Upload',
          meta: {
            title: 'External Collection / Upload'
          },
          component: () => import('@/views/collection/third-party/Upload.vue')
        },
        {
          path: '/collection/third-party/send-email-to-customer',
          name: 'Collection Third Party Send Email To Customer',
          meta: {
            title: 'External Collection / Notification / Send Email To Customer'
          },
          component: () => import('@/views/collection/third-party/SendEmailToCustomer.vue')
        },
        {
          path: '/collection/third-party/send-email-to-employer',
          name: 'Collection Third Party Send Email To Employer',
          meta: {
            title: 'External Collection / Notification / Send Email To Employer'
          },
          component: () => import('@/views/collection/third-party/SendEmailToEmployer.vue')
        },
        {
          path: '/collection/third-party/send-fax-to-employer',
          name: 'Collection Third Party Send Fax To Employer',
          meta: {
            title: 'External Collection / Notification / Send Fax To Employer'
          },
          component: () => import('@/views/collection/third-party/SendFaxToEmployer.vue')
        },
        {
          path: '/collection/third-party/download-file',
          name: 'Collection Third Party Download File',
          meta: {
            title: 'External Collection / Download File'
          },
          component: () => import('@/views/collection/third-party/DownloadFile.vue')
        },
        {
          path: '/collection/third-party/collection-management',
          name: 'Collection Third Party Collection Management',
          meta: {
            title: 'External Collection / Collection Management'
          },
          component: () => import('@/views/collection/third-party/CollectionManagement.vue')
        },
        {
          path: '/collection/third-party/third-party',
          name: 'Collection Third Party',
          meta: {
            title: 'External Collection / Third Party'
          },
          component: () => import('@/views/collection/third-party/ThirdParty.vue')
        }
      ]
    }
  ]
}

export const SettingViews = {
  path: '/',
  name: 'Setting',
  component: DefaultLayout,
  meta: {
    title: 'Setting',
    group: 'setting'
  },
  children: [
    {
      path: '/setting/complaint-filter-management',
      name: 'Complaint Filter Management',
      meta: {
        title: 'Setting / Complaint Filter Management'
      },
      component: () => import('@/views/setting/ComplaintFilterManagement.vue')
    },
    {
      path: '/setting/ssn-filter-management',
      name: 'SSN Filter Management',
      meta: {
        title: 'Setting / SSN Filter Management'
      },
      component: () => import('@/views/setting/SSNFilterManagement.vue')
    }
  ]
}

export const FilterViews = {
  path: '/',
  name: 'Filter',
  component: DefaultLayout,
  meta: {
    title: 'Filter',
    group: 'filter'
  },
  children: [
    {
      path: '/filter-management/high-risk-filter',
      name: 'Risk Filter Management',
      meta: {
        title: 'Filter / Risk Filter Management'
      },
      component: () => import('@/views/filter/PortfolioFilterManagement.vue')
    }
  ]
}
